import React from "react";
import { property } from "lodash";
import PropertyDetailPage from "../../../PropertyDetailPreview/Preview";

export default function PropertyDetail({ property, isChatScreen }) {
    return (
        <div>
            <div className="tw-mb-4 tw-p-6 tw-flex tw-flex-col tw-gap-2 tw-max-h-screen tw-overflow-y-auto">
                <h2 className="tw-text-xl tw-font-semibold tw-text-start tw-text-gray-800">Property Details</h2>
                <PropertyDetailPage publicProperty={property} isHeaderHide={true} isChatScreen={isChatScreen} />
            </div>
        </div>
    );
}
